export { TYPESENSE_ANY, TYPESENSE_COLLECTION_PRODUCTS } from '@Types/typesense/constants';

export const TYPESENSE_LABEL_PREFIX = 'typesense.';
